module.exports = __webpack_public_path__ + "img/modalBG.13faec12.png";